import { RadioGroup } from '@repo/ui';

export interface AppealOptionSelectorProps {
  value: 'appeal' | 'no-appeal';
  onValueChange: (value: 'appeal' | 'no-appeal') => void;
}

export const AppealOptionSelector = ({ value, onValueChange }: AppealOptionSelectorProps) => {
  return (
    <div className="flex flex-row gap-4 w-full">
      <RadioGroup
        name="appeal-option"
        value={value}
        orientation="horizontal"
        onValueChange={val => onValueChange(val as 'appeal' | 'no-appeal')}
        className="flex flex-row gap-4 w-full"
      >
        {/* No Appeal Card */}
        <label
          htmlFor="no-appeal-radio"
          style={{ animationDelay: '0.2s' }}
          className={`
            flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all opacity-0 animate-fade-in-left
            flex-1
            ${
              value === 'no-appeal'
                ? 'border-xtnd-blue bg-xtnd-light dark:bg-xtnd-blue/20'
                : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-xtnd-dark-800'
            }
          `}
        >
          <div className="flex items-start pt-0.5">
            <input
              type="radio"
              id="no-appeal-radio"
              name="appeal-option"
              value="no-appeal"
              checked={value === 'no-appeal'}
              onChange={() => onValueChange('no-appeal')}
              className="sr-only"
            />
            <span
              className={`
                inline-flex items-center justify-center rounded-full border
                transition-colors h-5 w-5
                ${
                  value === 'no-appeal'
                    ? 'border-xtnd-blue bg-xtnd-blue'
                    : 'border-gray-400 dark:border-gray-500 bg-white dark:bg-xtnd-dark-800'
                }
              `}
            >
              {value === 'no-appeal' && (
                <span className="inline-block rounded-full bg-white h-2.5 w-2.5" />
              )}
            </span>
          </div>
          <div className="flex-1">
            <div className="font-bold text-xtnd-dark dark:text-xtnd-light text-base mb-1">
              No Appeal
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Accept the BAR with no dispute and proceed to write-off evaluation.
            </div>
          </div>
        </label>

        {/* Appeal Card */}
        <label
          htmlFor="appeal-radio"
          style={{ animationDelay: '0.2s' }}
          className={`
            opacity-0 animate-fade-in-right
            flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all
            flex-1
            ${
              value === 'appeal'
                ? 'border-xtnd-blue bg-xtnd-light dark:bg-xtnd-blue/20'
                : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-xtnd-dark-800'
            }
          `}
        >
          <div className="flex items-start pt-0.5">
            <input
              type="radio"
              id="appeal-radio"
              name="appeal-option"
              value="appeal"
              checked={value === 'appeal'}
              onChange={() => onValueChange('appeal')}
              className="sr-only"
            />
            <span
              className={`
                inline-flex items-center justify-center rounded-full border
                transition-colors h-5 w-5
                ${
                  value === 'appeal'
                    ? 'border-xtnd-blue bg-xtnd-blue'
                    : 'border-gray-400 dark:border-gray-500 bg-white dark:bg-xtnd-dark-800'
                }
              `}
            >
              {value === 'appeal' && (
                <span className="inline-block rounded-full bg-white h-2.5 w-2.5" />
              )}
            </span>
          </div>
          <div className="flex-1">
            <div className="font-bold text-xtnd-dark dark:text-xtnd-light text-base mb-1">
              Appeal
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Dispute specific line items and initiate the appeal process.
            </div>
          </div>
        </label>
      </RadioGroup>
    </div>
  );
};
